import React, { useMemo } from "react";
import GlobalDirectoryFiltersSection from "../../../../../global/directory/GlobalDirectoryFiltersSection";
import {
  GlobalDirectoryColumnPicker,
  GlobalDirectoryExportMenu,
} from "../../../../../global/directory";
import {
  COLUMN_VISIBILITY_KEY,
  COLUMN_DEFS_FOR_FILTERS,
  RENEWAL_LIST_COLUMN_DEFS,
  isTruthy,
} from "../membershipRenewCommon";

export default function MembershipRenewListFiltersSection({
  draftFilters,
  onDraftFiltersChange,
  onClearColumnValueFilter,
  rows,
  columnVisibility,
  onColumnVisibilityChange,
  getExportData,
}) {
  const valueFilterOptions = useMemo(() => {
    if (!draftFilters.column) return [];
    const seen = new Set();
    const opts = [];
    for (const row of rows) {
      let label = "";
      if (draftFilters.column === "application_verified" || draftFilters.column === "payment_verified") {
        label = isTruthy(row[draftFilters.column]) ? "Verified" : "Not verified";
      } else {
        const raw = row[draftFilters.column];
        if (raw == null || raw === "") continue;
        label = String(raw);
      }
      if (!seen.has(label)) {
        seen.add(label);
        opts.push({ value: label, label });
      }
    }
    return opts.sort((a, b) =>
      a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: "base" }),
    );
  }, [draftFilters.column, rows]);

  return (
    <GlobalDirectoryFiltersSection
      className="ub-filters ub-directory-filters vml-directory-filters"
      searchLabel="Search student"
      searchPlaceholder="Name, code, phone"
      searchValue={draftFilters.student_search}
      onSearchChange={(v) => onDraftFiltersChange({ ...draftFilters, student_search: v })}
      columnLabel="Column"
      columnValue={draftFilters.column}
      onColumnChange={(v) => onDraftFiltersChange({ ...draftFilters, column: v, value: "" })}
      gridColumnDefs={COLUMN_DEFS_FOR_FILTERS}
      columnPlaceholderOption="Select"
      valueLabel="Value"
      valueValue={draftFilters.value}
      onValueChange={(v) => onDraftFiltersChange({ ...draftFilters, value: v })}
      valueOptions={valueFilterOptions}
      valuePlaceholderOption="All"
      onClear={onClearColumnValueFilter}
      clearFilterLabel="Clear filter"
      secondaryStart={
        <GlobalDirectoryColumnPicker
          columnDefs={RENEWAL_LIST_COLUMN_DEFS}
          visibility={columnVisibility}
          onVisibilityChange={onColumnVisibilityChange}
          storageKey={COLUMN_VISIBILITY_KEY}
        />
      }
      secondaryEnd={<GlobalDirectoryExportMenu getExportData={getExportData} filenameBase="volunteer_membership_renewals" />}
    />
  );
}
